// src/data/productsData.js
import CSLogo from '../assets/icons/cs.png';
import MastakashLogo from '../assets/icons/mastakash.png';
import FundReachLogo from '../assets/icons/fundreach.png';
import ChamaFlowLogo from '../assets/icons/chamaflow.png';
import ShoopkeeperLogo from '../assets/icons/shopkeeper.png';



const products = [
    {
      name: "CS Church Management",
      description: "Manage church operations, giving, and membership efficiently.",
      url: "https://cs.roshtech.co.ke",
      status: "live",
      logo: CSLogo
      
    },
    {
      name: "FundReach",
      description: "Social fundraising platform for individuals and organizations.",
      url: "https://fundreach.co.ke",
      status: "live",
      logo: FundReachLogo
    },
    {
      name: "MastaKash",
      description: "Simplify personal and group finances with our mobile app.",
      url: "https://mastakash.com",
      status: "live",
      logo: MastakashLogo
    },
    {
      name: "ChamaFlow",
      description: "Desktop software for managing chamas and microfinances.",
      url: "https://chamaflow.roshtech.co.ke/",
      status: "live",
      logo: ChamaFlowLogo
    },
     {
      name: "Shopkeeper",
      description: "POS Software for small and medium enterprises",
      url: null,
      status: "pending",
      logo: ShoopkeeperLogo
    }
  ];
  
  export default products;
  